import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import appbtnbg_en from "../Images/app_btn-bg.png";
import appbtnbg_ar from "../Images/app_btn-bg-ar.png";
import car from "../Images/car.png";
import img2 from "../Images/service_1.png";
import img1 from "../Images/service_2.png";

function Services() {
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  const getDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return "android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "ios";
    }

    return "web";
  };

  const links = {
    user: {
      android:
        "https://play.google.com/store/apps/details?id=io.tararide.user&hl=en_IN",
      ios: "https://apps.apple.com/kw/app/tara-ride/id6454933264",
    },
    driver: {
      android:
        "https://play.google.com/store/apps/details?id=io.tararide.driver&hl=en_IN",
      ios: "https://apps.apple.com/kw/app/tara-ride-driver/id6454933440",
    },
  };


  const handleRedirect = (type) => {
    const device = getDeviceType();

    if (device === "android") {
      window.open(links[type].android, "_blank");
    } else if (device === "ios") {
      window.open(links[type].ios, "_blank");
    } else {
      window.open(links[type].android, "_blank");
      window.open(links[type].ios, "_blank");
    }
  };

  return (
    <>
      <div className="services-wrapping-section pb-60" id="services">
        <div className="container">
          <div className="row align-items-center">
            <motion.div
              className="col-md-6"
              initial={{ opacity: 1, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <button className="appdes-btn"> {t("services_tag")} </button>{" "}
              <h1 className="services-title"> {t("services_title")} </h1>{" "}
              <p className="services-desc"> {t("services_desc")} </p>{" "}
              <div className="d-flex gap-3 services-btn-wrap">
                <button
                  className="wave-btn user-app"
                  onClick={() => handleRedirect("user")}
                >
                  {t("user_app")}{" "}
                  <i className="fa-regular fa-user ps-2"> </i>{" "}
                </button>{" "}
               {" "}
                <button
                  className="wave-btn"
                  onClick={() => handleRedirect("driver")}
                >
                  {" "}
                  {t("driver_app")}{" "}
                  <i className="fa-solid fa-user-tie ps-2"> </i>{" "}
                </button>{" "}
              </div>{" "}
            </motion.div>{" "}
           
            <motion.div
              className="col-md-6 d-flex justify-content-center gap-4 hero-images"
              initial={{ opacity: 1, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <motion.img
                src={img1}
                animate={{ y: [0, -15, 0] }}
                transition={{ repeat: Infinity, duration: 5 }}
                alt="app-preview-1"
              />

              <motion.img
                src={img2}
                className="second-img"
                animate={{ y: [0, 15, 0] }}
                transition={{ repeat: Infinity, duration: 5 }}
                alt="app-preview-2"
              />
            </motion.div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
      <div className="services-btn-layout position-relative">
        <div>
          <img
      src={isArabic ? appbtnbg_ar : appbtnbg_en}
      className="w-100 position-relative"
      alt="bg"
    />
        </div>{" "}
        <img src={car} className="car-img" alt="car" />
      </div>{" "}
    </>
  );
}

export default Services;
